import { useState, useMemo } from "react";
import { marked } from "marked";
import { useTranslation } from "../i18n";
import { Button } from "./ui/button";
import { Label } from "./ui/label";

export default function MarkdownEditor({ value, onChange, label }) {
  const { t } = useTranslation();
  const [mode, setMode] = useState("edit");

  const html = useMemo(() => {
    if (!value) return "";
    try {
      return marked.parse(value, { async: false });
    } catch {
      return value;
    }
  }, [value]);

  return (
    <div>
      <Label>{label}</Label>
      <div className="flex gap-1 mb-2">
        <Button
          variant={mode === "edit" ? "default" : "secondary"}
          size="sm"
          onClick={() => setMode("edit")}
          type="button"
        >
          {t("markdown.editor")}
        </Button>
        <Button
          variant={mode === "preview" ? "default" : "secondary"}
          size="sm"
          onClick={() => setMode("preview")}
          type="button"
        >
          {t("markdown.preview")}
        </Button>
      </div>
      {mode === "edit" ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={8}
          className="flex w-full rounded-lg border border-c-gray-400/30 bg-c-gray-500 px-3 py-2 text-sm text-white placeholder:text-c-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-0 font-mono resize-y h-[200px]"
          placeholder={t("markdown.placeholder")}
        />
      ) : (
        <div
          className="bg-c-gray-500 text-sm rounded-lg block w-full p-2.5 h-[200px] overflow-y-auto markdown-preview"
          dangerouslySetInnerHTML={{
            __html:
              html ||
              `<p class='text-c-gray-400'>${t("markdown.noContent")}</p>`,
          }}
        />
      )}
    </div>
  );
}
